import { getCurrentYear, getMaxSelectableYear } from '../helpers/year';

const getDefaultYear = () => getCurrentYear();

const normalizeSelectedYear = (year) => {
  if (!Number.isFinite(year)) {
    return getDefaultYear();
  }

  const maxSelectableYear = getMaxSelectableYear();

  return year > maxSelectableYear ? getDefaultYear() : year;
};

const INITIAL_STATE = {
  selectedYear: getDefaultYear(),
  calendarYear: getDefaultYear(),
};

function settingsReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'SET_SELECTED_YEAR': {
      const nextYear = normalizeSelectedYear(action.year);
      return {
        ...state,
        selectedYear: nextYear,
        calendarYear: getCurrentYear(),
      };
    }

    default:
      return state;
  }
}

export default settingsReducer;
